/**
 * Created by Abner Sui on 04/10/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { TileColumn, TileColumnDataType, TileColumnConfig, TileColumnGroupSetting, TileColumnSetting } from '../../../../tamalelibs/models/tile-column.model';
import { BriefObject } from '../../../../tamalelibs/models/brief-object';
import { BriefConfig } from '../../../../widgets/widgets.model';
import { TileModel } from '../../../../tamalelibs/models/tile.model';
import { businessConstants } from '../../../../constants/business.constants';
import { StringLiteralsPipe } from '../../../../pipes/translate.pipe';

@Component({
    selector: 'tile-entity-column-detail',
    templateUrl: './tile-entity-column-detail.component.html',
    styleUrls: ['./tile-column-detail.component.scss']
})
export class TileEntityColumnDetailComponent implements OnInit, OnDestroy {

    @Input()
    config: TileColumn;
    @Input()
    wholeConfig: TileModel;
    @Input()
    briefConfig: BriefConfig;

    displayList = businessConstants.displayList;
    displayAsList = businessConstants.displayAsList;
    selectedDisplay: BriefObject;
    selectedDisplayAs: BriefObject;
    dataTypeList = businessConstants.dataTypeList;
    selectedDataType: BriefObject;
    parameterValueList: Array<BriefObject> = [];
    selectedParameterValue: BriefObject;
    entitiesSameRowDisabled: boolean;
    isShowDisplayAs = false;

    ngOnInit(): void {

        if (this.config.default) {
            this.selectedDisplay = this.displayList.find(item => item.id === this.config.settings.display);
        } else {
            this.selectedDataType = this.dataTypeList.find(item => item.value.toLowerCase() === this.config.dataType.toLowerCase());
            this.wholeConfig.columns.forEach(item => {
                if (item.dataType === TileColumnDataType.ENTITY) {
                    this.parameterValueList.push(new BriefObject(item.guid, item.title));
                }
            });
            this.selectedParameterValue = this.parameterValueList.find(item => item.id === this.config.config.parameterValue);
            if (this.config.name.toLowerCase() === StringLiteralsPipe.translate('general.address')) {
                this.isShowDisplayAs = true;
                this.selectedDisplayAs = this.displayAsList.find(item => item.id === this.config.settings.display);
            }
        }
        const tempGroupList: Array<TileColumnGroupSetting> = this.wholeConfig.columnGroups.filter(item => item.display !== 0);
        this.entitiesSameRowDisabled = tempGroupList && tempGroupList.length > 0;
    }

    ngOnDestroy(): void {
    }

    onDisplayAsChange(value) {
        this.selectedDisplayAs = value;
        if (!this.config.settings) {
            this.config.settings = new TileColumnSetting();
        }
        this.config.settings.display = this.selectedDisplayAs.id;
    }

    onParameterValueChange(value) {
        this.selectedParameterValue = value;
        if (!this.config.config) {
            this.config.config = new TileColumnConfig();
        }
        this.config.config.parameterValue = this.selectedParameterValue.id;
    }

    onShowEntitiesSameRowChange(value) {
        if (this.config.default) {
            this.config.showEntitiesSameRow = value;
            this.wholeConfig.columns.forEach(item => {
                if (item.default) {
                    item.showEntitiesSameRow = this.config.showEntitiesSameRow;
                }
            });
            if (this.config.showEntitiesSameRow) {
                this.wholeConfig.options.showRowForEveryEntity = false;
            }
        }
    }
}
